import React from "react";
import BannerSlider from "./BannerSlider";
import About from "./About";
import ProductsGrid from "./ProductsGrid";
import PopularCategories from "./PopularCategories";
import Deals from "./Deals";
import Newsletter from "./Newsletter";
import Blog from "./Blog";
import AboutProduct from "./AboutProduct";

const Home = () => {
  return (
    <>
      <BannerSlider />
      <About />
      <AboutProduct />
      <ProductsGrid is3x3={false} isHome={true} />
      <PopularCategories />
      <Deals />
      <Newsletter />
      <Blog />
    </>
  );
};

export default Home;
